import { render, staticRenderFns } from "./CampaignVariantsTable.vue?vue&type=template&id=8b2c0d74&"
import script from "./CampaignVariantsTable.vue?vue&type=script&lang=js&"
export * from "./CampaignVariantsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports